module.exports = __webpack_public_path__ + "img/icon-checkup.b3a7aff7.svg";